import { PrepopulateXeroBankAccountParams } from './BillsInformation.types';

export const usePrepopulateXeroBankAccount = ({
    lastUsedXeroBankAccounts,
    changeBankAccount,
    items,
    prevItems,
}: PrepopulateXeroBankAccountParams) => {
    if (items === prevItems) return;

    items.forEach((item) => {
        const bankAccountIsEmpty = !item.bankAccount;
        const justChangedSourceCurrency =
            prevItems &&
            item.sourceCurrency?.id !==
                prevItems.find((prevItem) => prevItem.xeroBillInvoiceRequestId === item.xeroBillInvoiceRequestId)
                    ?.sourceCurrency?.id;

        if (bankAccountIsEmpty || justChangedSourceCurrency) {
            const lastUsedXeroBankAccount = lastUsedXeroBankAccounts?.find(
                (bankAccount) => bankAccount.currency === item.sourceCurrency?.id
            );

            const newBankAccount = lastUsedXeroBankAccount
                ? {
                      id: lastUsedXeroBankAccount.xeroBankAccountId,
                      text: lastUsedXeroBankAccount.xeroBankAccountCode
                          ? `${lastUsedXeroBankAccount.xeroBankAccountCode} - ${lastUsedXeroBankAccount.xeroBankAccountName}`
                          : lastUsedXeroBankAccount.xeroBankAccountName,
                  }
                : null;

            const shouldChangeBankAccount =
                (newBankAccount && newBankAccount?.id !== item.bankAccount?.id) ||
                (item.bankAccount && !newBankAccount);

            if (shouldChangeBankAccount) {
                changeBankAccount(item.xeroBillInvoiceRequestId, newBankAccount, item.sourceCurrency);
            }
        }
    });
};
